import React, { useState } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Paper,
  alpha,
  IconButton,
  Button
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import UserStoryTable from './UserStoryTable';
import TaskTable from './TaskTable';

const UserStoryAndTaskTable = ({ onBack}) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const TabPanel = ({ children, value, index }) => {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`tabpanel-${index}`}
        aria-labelledby={`tab-${index}`}
      >
        {value === index && (
          <Box sx={{ pt: 1 }}>
            {children}
          </Box>
        )}
      </div>
    );
  };

  // Handle back button click
  const handleBackClick = () => {
    if (onBack) {
      onBack();
    }
  };

  return (
    <Box>
      {/* Back Arrow Header */}
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center',        
        p: 1,
       
      }}>
        <IconButton 
          onClick={handleBackClick}
          sx={{
            mr: 1,
            color: '#64748b',
            '&:hover': {
              backgroundColor: alpha('#64748b', 0.1)
            }
          }}
        >
          <ArrowBack />
        </IconButton>
        <Typography variant="body1" sx={{ color: '#64748b', fontWeight: 500 }}>
          Back to Projects Table
        </Typography>
      
      </Box>

      <Paper
        sx={{
          borderRadius: 2,
          boxShadow: '0 1px 12px rgba(0,0,0,0.06)',
          border: '1px solid',
          borderColor: alpha('#3b82f6', 0.1),
          overflow: 'hidden'
        }}
      >
        <Box
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            px: 2,
            background: alpha('#f8fafc', 1)
          }}
        >
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            aria-label="user story and task tabs"
            sx={{
              '& .MuiTab-root': {
                textTransform: 'none',
                fontWeight: 600,
                fontSize: '0.875rem',
                minHeight: 48
              },
              '& .Mui-selected': {
                color: '#3b82f6'
              },
              '& .MuiTabs-indicator': {
                backgroundColor: '#3b82f6',
                height: 3
              }
            }}
          >
            <Tab
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Box
                    sx={{
                      width: 6,
                      height: 6,
                      borderRadius: '50%',
                      backgroundColor: activeTab === 0 ? '#8b5cf6' : alpha('#8b5cf6', 0.5)
                    }}
                  />
                  <Typography variant="body2" fontWeight={600}>
                    User Stories
                  </Typography>
                </Box>
              }
              id="tab-0"
              aria-controls="tabpanel-0"
            />
            <Tab
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Box
                    sx={{
                      width: 6,
                      height: 6,
                      borderRadius: '50%',
                      backgroundColor: activeTab === 1 ? '#10b981' : alpha('#10b981', 0.5)
                    }}
                  />
                  <Typography variant="body2" fontWeight={600}>
                    Tasks
                  </Typography>
                </Box>
              }
              id="tab-1"
              aria-controls="tabpanel-1"
            />
          </Tabs>
        </Box>

        <Box sx={{ p: 2 }}>
          <TabPanel value={activeTab} index={0}>
            <UserStoryTable />
          </TabPanel>
          
          <TabPanel value={activeTab} index={1}>
            <TaskTable />
          </TabPanel>
        </Box>
      </Paper>
    </Box>
  );
};

export default UserStoryAndTaskTable;